// extracted by mini-css-extract-plugin
module.exports = {"lineH24":"styles_lineH24__1L7-Z"};